module.exports = __webpack_public_path__ + "img/f5.a8bbf504.png";